<template>
  <div style="height: 100%;">
    <NavHeader :lang="currentLang" />
    <router-view :lang="currentLang" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'


import NavHeader from './components/NavHeader'
import { Alert } from 'element-ui'

export default {
  components: {
    NavHeader
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        const preLang = window.localStorage.getItem("lang")
        let url = window.location.href
        if (url.indexOf("/#/zh-cn/") < 0 && url.indexOf("/#/zh-tw/") < 0 && url.indexOf("/#/en-us/") < 0) {
          const arr = url.split("#")
          url = arr[0] + "#/en-us/swapV2/changelog"
          window.location.href = url
          window.localStorage.setItem("lang", "en-US")
          window.location.reload()
        } else {
          const arr = url.split("/#/")
          const arr1 = arr[1].split("/")
          // alert(arr1.length)
          if (arr1.length < 3) {
            const arr3 = url.split("#")
            let modl = ""
            if (url.indexOf("/swapV2") > -1) {
              modl = "swapV2"
            } else if (url.indexOf("/cswap") > -1) {
              modl = "cswap"
            } else if (url.indexOf("/spot") > -1) {
              modl = "spot"
            } else if (url.indexOf("/common") > -1) {
              modl = "common"
            } else if (url.indexOf("/standard") > -1) {
              modl = "standard"
            } else if (url.indexOf("/copyTrade") > -1) {
              modl = "copyTrade"
            } else if (url.indexOf("/agent") > -1) {
              modl = "agent"
            } else {
              modl = "swapV2"
            }
            if (preLang == "en-US")
              url = arr3[0] + "#/en-us/" + modl + "/changelog"
            if (preLang == "zh-hans")
              url = arr3[0] + "#/zh-cn/" + modl + "/changelog"
            if (preLang == "zh-tw")
              url = arr3[0] + "#/zh-tw/" + modl + "/changelog"
            window.location.href = url
            window.location.reload()
            if (this.$route.query.type) {//需要监听的参数
              this.type = this.$route.query.type
            }
            return

          }
          let newLang = arr1[0]
          if (arr1[0] == 'en-us') {
            newLang = "en-US"
          } if (arr1[0] == 'zh-cn') {
            newLang = "zh-hans"
          }
          if (newLang != preLang) {
            window.localStorage.setItem("lang", newLang)
            window.location.reload()
          }
        }

        if (this.$route.query.type) {//需要监听的参数
          this.type = this.$route.query.type
        }
      }
    }
  },
  computed: {
    ...mapGetters(['currentLang'])
  },
}
</script>


// WEBPACK FOOTER //
// src/Main.vue